import React from "react";
import { Spinner } from "react-bootstrap";

export default function LoadSpinner() {
    return (
        <center><Spinner animation="border" role="status" variant="danger">
            <span></span>
        </Spinner></center>
    );
  }